class ProductStickyBlock {
    constructor() {
        this.stickyBlock = document.querySelector('.sticky-block-product');
        this.firstColumn = document.querySelector('.content-first-column');
        this.originalForm = document.querySelector('#add-to-cart-or-refresh');
        this.stickyForm = document.querySelector('#add-to-cart-or-refresh-sticky');
        // Trova il bottone "Aggiungi al carrello" nel form originale
        this.addToCartButton = this.originalForm ? this.originalForm.querySelector('.add-to-cart') : null;

        // Verifica se gli elementi necessari esistono
        if (!this.stickyBlock || !this.firstColumn || !this.originalForm || !this.stickyForm) {
            return;
        }

        this.isActive = false;

        // Calcola l'altezza dell'header dinamicamente
        this.calculateHeaderHeight();

        this.init();

        // Sincronizza varianti/ hidden: second-column → sticky
        this.originalForm.addEventListener('change', () => {
            console.log('[StickyBlock] originalForm change', { isActive: this.isActive });
            if (this.isActive) {
                this.syncForms();
            }
        });

        // Quando l’utente cambia la qty nella sticky, aggiorna la variabile “vera” (#quantity_wanted) nella second-column
        const stickyQtyEl = this.stickyForm.querySelector('#quantity_wanted_sticky');
        if (stickyQtyEl) {
            const syncStickyToOriginal = () => {
                const originalQty = this.originalForm.querySelector('#quantity_wanted');
                if (originalQty && stickyQtyEl.value !== originalQty.value) {
                    const min = parseInt(stickyQtyEl.getAttribute('min'), 10) || 1;
                    let val = parseInt(stickyQtyEl.value, 10) || min;
                    if (val < min) val = min;
                    originalQty.value = val;
                    stickyQtyEl.value = val;
                    console.log('[StickyBlock] sticky qty → original', { qty: val });
                }
            };
            stickyQtyEl.addEventListener('change', syncStickyToOriginal);
            stickyQtyEl.addEventListener('input', syncStickyToOriginal);

            const min = parseInt(stickyQtyEl.getAttribute('min'), 10) || 1;
            const max = parseInt(stickyQtyEl.getAttribute('data-quantity'), 10) || 99999;
            const allowOosp = stickyQtyEl.getAttribute('data-allow-oosp') === '1';

            this.stickyForm.querySelector('.js-sticky-qty-minus')?.addEventListener('click', () => {
                let val = parseInt(stickyQtyEl.value, 10) || min;
                if (val > min) {
                    val--;
                    stickyQtyEl.value = val;
                    syncStickyToOriginal();
                }
            });
            this.stickyForm.querySelector('.js-sticky-qty-plus')?.addEventListener('click', () => {
                let val = parseInt(stickyQtyEl.value, 10) || min;
                const limit = allowOosp ? 99999 : max;
                if (val < limit) {
                    val++;
                    stickyQtyEl.value = val;
                    syncStickyToOriginal();
                }
            });
        }
    }

    syncForms() {
        // Sincronizza tutti gli input hidden dal form originale a quello sticky (escluso qty: quello sticky resta e va solo aggiornato)
        const originalInputs = this.originalForm.querySelectorAll('input[type="hidden"]');
        const stickyInputs = this.stickyForm.querySelectorAll('input[type="hidden"]');
        const stickyQtyInput = this.stickyForm.querySelector('#quantity_wanted_sticky') || this.stickyForm.querySelector('input[name="qty"]');

        console.log('[StickyBlock] syncForms called', {
            originalHiddenCount: originalInputs.length,
            stickyHiddenCount: stickyInputs.length,
            stickyQtyElement: !!stickyQtyInput,
            stickyQtyId: stickyQtyInput ? stickyQtyInput.id : null
        });

        // Rimuovi solo gli hidden che non sono il qty sticky (altrimenti il qty sparirebbe e non sarebbe più sincronizzabile)
        stickyInputs.forEach(input => {
            if (input.id === 'quantity_wanted_sticky' || input.name === 'qty') return;
            input.remove();
        });

        // Aggiungi gli input hidden dal form originale (token, id_product, id_customization, ecc.)
        originalInputs.forEach(input => {
            const clonedInput = input.cloneNode(true);
            if (clonedInput.id) {
                clonedInput.id = clonedInput.id + '_sticky';
            }
            this.stickyForm.appendChild(clonedInput);
        });

        // Sincronizza il valore della quantità
        const originalQty = this.originalForm.querySelector('#quantity_wanted');
        const stickyQty = this.stickyForm.querySelector('#quantity_wanted_sticky') || this.stickyForm.querySelector('input[name="qty"]');
        const prevStickyVal = stickyQty ? stickyQty.value : 'N/A';
        const newVal = originalQty ? originalQty.value : 'N/A';

        if (originalQty && stickyQty) {
            stickyQty.value = originalQty.value;
            console.log('[StickyBlock] qty synced', { from: originalQty.value, to: prevStickyVal, now: stickyQty.value });
        } else {
            console.warn('[StickyBlock] qty NOT synced', {
                originalQtyFound: !!originalQty,
                stickyQtyFound: !!stickyQty,
                originalVal: originalQty ? originalQty.value : null
            });
        }
    }

    calculateHeaderHeight() {
        // Calcola l'altezza dell'header visibile in tempo reale
        const headerElements = [
            document.querySelector('.header-banner'),
            document.querySelector('.header-top'),
            document.querySelector('.header-nav'),
            document.querySelector('nav.header-nav'),
            document.querySelector('header'),
            document.querySelector('#header'),
            document.querySelector('.header')
        ].filter(el => el !== null);


        // Calcola l'altezza totale dell'header VISIBILE
        let totalHeaderHeight = 0;
        headerElements.forEach(element => {
            const rect = element.getBoundingClientRect();
            // Solo se l'elemento è visibile (top >= 0 e height > 0)
            if (rect.top >= 0 && rect.height > 0) {
                const height = rect.height;
                totalHeaderHeight += height;
            } else {
            }
        });


        // Se non troviamo elementi dell'header, usa un valore di fallback
        if (totalHeaderHeight === 0) {
            totalHeaderHeight = 135; // valore di fallback
        }

        // Applica il margin-top dinamicamente
        this.stickyBlock.style.marginTop = totalHeaderHeight + 'px';

        // Salva l'altezza per uso futuro
        this.headerHeight = totalHeaderHeight;
    }

    init() {
        // Aggiungi event listener per lo scroll
        window.addEventListener('scroll', this.handleScroll.bind(this));

        // Aggiungi event listener per il resize della finestra
        window.addEventListener('resize', this.handleResize.bind(this));

        // Controllo iniziale per dispositivi mobili
        this.checkInitialState();

        // Esegui il controllo iniziale
        this.handleScroll();

    }

    checkInitialState() {
        // Stesso comportamento desktop e mobile: active solo quando il pulsante esce (gestito da handleScroll)
    }

    handleResize() {
        // Ricalcola l'altezza dell'header quando la finestra viene ridimensionata
        this.calculateHeaderHeight();
        // Esegui il controllo dello scroll
        this.handleScroll();
    }

    handleScroll() {
        // Stessa logica per desktop e mobile: attiva solo quando il pulsante "Aggiungi al carrello" esce dalla vista
        if (this.addToCartButton) {
            const buttonRect = this.addToCartButton.getBoundingClientRect();
            // Controlla se la parte superiore del bottone è sotto l'header
            const isButtonUnderHeader = buttonRect.top < this.headerHeight;

            if (isButtonUnderHeader && !this.isActive) {
                this.activateStickyBlock();
            } else if (!isButtonUnderHeader && this.isActive) {
                this.deactivateStickyBlock();
            }
        } else {
            // Fallback: usa la logica originale se il bottone non è trovato
            const firstColumnRect = this.firstColumn.getBoundingClientRect();
            const isOutOfViewport = firstColumnRect.bottom < 0;

            if (isOutOfViewport && !this.isActive) {
                this.activateStickyBlock();
            } else if (!isOutOfViewport && this.isActive) {
                this.deactivateStickyBlock();
            }
        }
    }

    activateStickyBlock() {

        // Ricalcola l'altezza dell'header solo se non è già attivo
        if (!this.isActive) {
            this.calculateHeaderHeight();
        }

        this.isActive = true;
        this.stickyBlock.classList.add('active');
        console.log('[StickyBlock] activated, syncing forms...');

        // Sincronizza i dati tra i due form
        this.syncForms();

        // Aggiungi padding inferiore al footer basato sull'altezza del sticky block (solo per risoluzioni < 767px)
        const windowWidth = window.innerWidth;
        if (windowWidth < 991) {
            const footer = document.getElementById('footer');
            if (footer) {
                const stickyBlockHeight = this.stickyBlock.offsetHeight;
                footer.style.paddingBottom = (stickyBlockHeight + 10) + 'px';
            }
        }
    }

    deactivateStickyBlock() {
        this.isActive = false;
        this.stickyBlock.classList.remove('active');

        // Rimuovi il padding inferiore dal footer (solo se era stato applicato per risoluzioni < 767px)
        const windowWidth = window.innerWidth;
        if (windowWidth < 991) {
            const footer = document.getElementById('footer');
            if (footer) {
                footer.style.paddingBottom = '';
            }
        }
    }

    destroy() {
        // Riporta il pulsante nella posizione originale prima di distruggere
        if (this.isActive) {
            this.deactivateStickyBlock();
        }

        // Rimuovi event listeners
        window.removeEventListener('scroll', this.handleScroll.bind(this));
        window.removeEventListener('resize', this.handleResize.bind(this));
    }
}

// Inizializza la classe quando il DOM è pronto
document.addEventListener('DOMContentLoaded', () => {
    const stickyBlock = document.querySelector('.sticky-block-product');

    // Verifica se siamo nella pagina prodotto e se esiste l'elemento sticky-block-product
    if (stickyBlock) {
        new ProductStickyBlock();
    }
});

// Esporta la classe per uso esterno se necessario
if (typeof module !== 'undefined' && module.exports) {
    module.exports = ProductStickyBlock;
}
